import { createContext } from 'react'

export type PageType = 'begin' | 'select_reason' | 'confirm' | 'complete'

interface Context {
  pageType: PageType
  updatePageType: (nextPageType: PageType) => void
  isVisiblePageBack: boolean
}

export const WithdrawalPageTypeContext = createContext<Context>({
  pageType: 'begin',
  updatePageType: () => undefined,
  isVisiblePageBack: false,
})
